import { render, staticRenderFns } from "./retire_info.vue?vue&type=template&id=3b882e7f"
import script from "./retire_info.vue?vue&type=script&lang=js"
export * from "./retire_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b882e7f')) {
      api.createRecord('3b882e7f', component.options)
    } else {
      api.reload('3b882e7f', component.options)
    }
    module.hot.accept("./retire_info.vue?vue&type=template&id=3b882e7f", function () {
      api.rerender('3b882e7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appManage/retire_info.vue"
export default component.exports